module.exports = __webpack_public_path__ + "img/flot-fyr-paa-snap-3.84c0eaf9.png";